import { render, staticRenderFns } from "./BtnShow.vue?vue&type=template&id=0ff12e78&scoped=true"
import script from "./BtnShow.vue?vue&type=script&lang=js"
export * from "./BtnShow.vue?vue&type=script&lang=js"
import style0 from "./BtnShow.vue?vue&type=style&index=0&id=0ff12e78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff12e78",
  null
  
)

export default component.exports